/** Minimum touch target (px) — aligned with `--tra-touch-min` in tokens.css / GLOBAL_UI_UX_STANDARDS */
export const MIN_TOUCH_TARGET_PX = 48;

/**
 * Merge aria / data props for TRA primitives (later wins).
 * @param {...(Record<string, unknown>|null|undefined)} objects
 */
export function mergeAria(...objects) {
  return Object.assign({}, ...objects.filter(Boolean));
}

/** True when the user prefers reduced motion. */
export function prefersReducedMotion() {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
